export default __webpack_public_path__ + "static/media/CylinderSizesImg.5df484d7.jpg";